export function scheduleAnimation(delay: number, callback: () => void): number {
  return window.setTimeout(callback, delay);
}
